"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STRUCTURE_TYPES = void 0;
exports.STRUCTURE_TYPES = {
    hy: {
        sell: {
            new_building: 'norakaruyc-',
            apartment: 'norakaruyc-bnakaran-',
            house: 'norakaruyc-sepakan-tun-',
            commercial: 'norakaruyc-komercion-tarack-',
        },
        rent: {
            new_building: 'norakaruyc-',
            apartment: 'norakaruyc-bnakaran-',
            house: 'norakaruyc-arandznatun-',
            commercial: 'norakaruyc-grasenyakayin-taracq-',
        },
    },
    ru: {
        sell: {
            new_building: 'novostroika-',
            apartment: 'kvartiri-v-novostroikax-',
            house: 'chastnie-doma-novostroiki-',
            commercial: 'kommercheskaya-nedvizhimost-v-novostroikax-',
        },
        rent: {
            new_building: 'novostroika-',
            apartment: 'kvartiri-v-novostroikax-',
            house: 'chastnie-doma-novostroiki-',
            commercial: 'kommercheskaya-nedvizhimost-v-novostroikax-',
        },
    },
    en: {
        sell: {
            new_building: '',
            apartment: 'new-apartment-',
            house: 'new-house-',
            commercial: 'new-commercial-',
        },
        rent: {
            new_building: '',
            apartment: 'new-apartment-',
            house: 'new-house-',
            commercial: 'new-commercial-',
        },
    },
};
